import { DataGridPremium } from "@mui/x-data-grid-premium";
import { useSeasons } from "../../redux/season/seasonHooks";
import { useProjects } from "../../redux/project/projectHooks";
import { useGigs } from "../../redux/gig/gigHooks";
import { Box } from "@mui/material";
import { LinearProgress, Sheet, Tooltip, Typography } from "@mui/joy";
import { Cover } from "../cover/cover";
import { setFormOpen, setSelectedSeasonIDs } from "../../reducers/rhapsody";
import { useDispatch } from "react-redux";
import { Toolbar } from "../gigsDatagrid/gigsDatagrid";

/**
 *
 * @returns {ReactElement} SeasonsDatagrid page
 */
export function SeasonsDatagrid() {
  const { seasons: _seasons, isLoading: l1 } = useSeasons();
  const { projects, isLoading: l2 } = useProjects();
  const { gigs, isLoading: l3 } = useGigs();
  const dispatch = useDispatch();

  const seasons = _seasons.reduce((a, v) => {
    a.push(v.inject({ projects, gigs }));
    return a;
  }, []);

  return (
    <DataGridPremium
      slots={{
        toolbar: Toolbar,
      }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
        },
      }}
      pagination
      pageSizeOptions={[25]}
      loading={l1 || l2 || l3}
      rows={seasons ?? []}
      onRowClick={(p) => {
        if (p.row.sourceID === 420) {
          dispatch(
            setSelectedSeasonIDs({
              id: p.row.id,
              sourceID: p.row.sourceID,
              sourceRecordID: p.row.sourceRecordID,
            })
          );
          dispatch(setFormOpen({ isOpen: true, formID: "season" }));
        }
      }}
      columns={[
        {
          field: "sourceID",
          headerName: "",
          width: 12,
          renderCell: (p) =>
            p.value !== 420 ? (
              <Tooltip
                arrow
                size="sm"
                sx={{ maxWidth: 150, textAlign: "center" }}
                variant="outlined"
                title="Thie item cannot be edited. It is controlled by an organization using Rhapsody."
              >
                <i className="fa-solid fa-lock"></i>
              </Tooltip>
            ) : (
              <Box />
            ),
        },
        {
          field: "coverURL",
          headerName: "Cover",
          width: 80,
          renderCell: (c) => {
            const season = c.row;
            return <Cover type="season" url={season.coverURL} />;
          },
        },
        { field: "name", headerName: "Name", width: 500 },
        {
          field: "date",
          headerName: "Date & Description",
          width: 300,
          renderCell: (c) => {
            const season = c.row;

            return (
              <Box>
                <Typography level="body2">
                  <b>{season?.dateDescription()}</b>
                </Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Typography level="body3">
                    {season.projectCount()} Project
                    {season.projectCount() != 1 ? "s" : ""}
                  </Typography>
                </Box>
              </Box>
            );
          },
        },
        {
          field: "completion",
          headerName: "Completion",
          width: 200,
          renderCell: (c) => {
            const season = c.row;
            return (
              <Box
                sx={{ display: "flex", flexDirection: "column", width: "100%" }}
              >
                <Typography level="body2">
                  {season.completedProjectCount()}/{season.projectCount()}
                </Typography>
                <LinearProgress
                  thickness={6}
                  determinate
                  value={season.completion()}
                />
              </Box>
            );
          },
        },
      ]}
      initialState={{
        pinnedColumns: {
          right: ["completion"],
        },
        pagination: {
          paginationModel: {
            pageSize: 25,
          },
        },
      }}
    />
  );
}
